import _ from "lodash";
import PropTypes from "prop-types";

export const focusable =
'a:not([disabled]), button:not([disabled]), [tabindex]:not([disabled]):not([tabindex="-1"])';

export const keys = {
    tab: 9,
    enter: 13,
    escape: 27,
    space: 32,
    left: 37,
    up: 38,
    right: 39,
    down: 40
};

export const saveToDisk = ({contents, fileName}) => {
    if (window.navigator.msSaveOrOpenBlob) { // EDGE workaround
        const blob = new Blob([decodeURIComponent(encodeURI(contents))], { type: 'text/csv;charset=utf-8;' });
        navigator.msSaveBlob(blob, fileName);
    } else {
        const element = document.createElement('a');
        element.setAttribute('href', `data:text/plain;charset=utf-8,${encodeURIComponent(contents)}`);
        element.setAttribute('download', fileName);
        element.style.display = 'none';
        document.body.appendChild(element);

        element.click();

        document.body.removeChild(element);
    }
}

/**
 Extracts error from given error object
 Handles:
    - errors from axios (have e.response.data)
        => error can the the response payload, message property of response payload, or nested payload.error.message
    - error which is Error/object that has message property
    - error which is only a string
 * @returns {*|string}
 */
export const extractErrorMessage = (e, errMsgKey) => {
    const data = e?.response?.data;
    if (_.isString(data)) {
        return data;
    } else if (_.isObject(data)) {
        if (data.message) {
            return data.message
        } else if (_.isString(data?.error)) {
            return data.error;
        } else if (data && _.isString(data[errMsgKey])) {
            return data[errMsgKey];
        } else {
            return data?.error?.message || "Unknown";
        }

    } else if (_.isString(e)) {
        return e;
    } else {
        return e.message;
    }
};

export const readFileFromEvent = (e) => {
    return new Promise((resolve) => {
        const file = e.target.files[0];
        if (file) {
            const fileReader = new FileReader();
            fileReader.readAsText(file);
            fileReader.onloadend = () => {
                resolve({
                    fileName: file.name,
                    contents: fileReader.result,
                    fileSize: file.size
                })
            };
        }
    });
};

export const matchPropType = (propType) => {
    let isRequired = false;

    const type = _.findKey(PropTypes, (val) => {
        if(propType === val.isRequired) {
            isRequired = true;
            return true;
        } else {
            return propType === val
        }
    }) || "uknown";

    return {
        type,
        isRequired
    }
};
